export default function generatePriceBeforeDiscount(
  price: number,
  discountPercentage: number
) {
  const result = price / ((100 - discountPercentage) / 100);
  return Math.round(result);
}
